function Page404() {
    return (
        <>
            <h1>Page404</h1>
        </>
    );
}

export default Page404;